module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/AT-8f80f78562f6b43213fc11497a9b7d92.png";